exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-tamanio {\n    width: 100% !important;\n    height: 200% !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/app/components/desktop/desktop/desktop.component.css
// module id = ../../../../../src/app/components/desktop/desktop/desktop.component.css
// module chunks = main